import { render } from "./Card.vue?vue&type=template&id=5451088b&scoped=true"
import script from "./Card.vue?vue&type=script&lang=js"
export * from "./Card.vue?vue&type=script&lang=js"

import "./Card.vue?vue&type=style&index=0&id=5451088b&lang=scss&scoped=true"
import "./Card.vue?vue&type=style&index=1&id=5451088b&lang=scss&global=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5451088b"]])

export default __exports__